import client from '../../../lib/client';

import { ENDPOINT } from '../constants';

function listDataSettings(args) {
  return client.get(ENDPOINT, {
    params: {
      ...args,
    },
  });
}

function updateDataSettings(args) {
  return client.put(`${ENDPOINT}`, args, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export { listDataSettings, updateDataSettings };
